
import $ from "jquery"
import Promise from "plugins/bluebird"

interface Result {
  modal_shown: boolean
  modal_hidden_promise: Promise<void>
}

const init_with_promise = (): Promise<Result> => {
  return new Promise((resolve, reject) => {
    try{
      const $container_for_modal_content = $("#layout--application__first-time-user-modal-wrapper")
      // When it does not exists, it means it should not be shown
      if ($container_for_modal_content.length === 0 ){
        resolve({
          modal_shown:          false,
          modal_hidden_promise: Promise.resolve(),
        })
        return
      }

      // # == Temporary ==
      // ## Always hide the modal during the period with ad modal for Nam Fung active
      resolve({
        modal_shown:          false,
        modal_hidden_promise: Promise.resolve(),
      })
      return

      // Whole chunk of code not run due to return statement above
      // Uncomment once the code upstair removed

      // let $modal = Modal.showModalWithContent(
      //   $container_for_modal_content.html(),
      //   {customContent: true},
      // )
      // let modal_hidden_deferred = Promise.defer()
      // // Resolve the promise AFTER hidden
      // $modal.on("hidden", () => modal_hidden_deferred.resolve())
      // resolve({
      //   modal_shown: true,
      //   modal_hidden_promise: modal_hidden_deferred.promise,
      // })

      // // # Some mobile specifc style fix?
      // if (!Page.isForMobile())
      //   return

      // let adjust_vertical_position = ()=> {
      //   let $inner_container =
      //     $(".cell--app--first_time_user_modal--default_style.modal")
      //     .find(".cell--app--first_time_user_modal--default_style__inner")

      //   if ($inner_container.length ===  0){
      //     setTimeout(adjust_vertical_position, 500)
      //     return
      //   }

      //   let inner_container_height = $inner_container.height()
      //   let view_port_height = ($(window).height() || 0)

      //   if (inner_container_height === 0){
      //     setTimeout(adjust_vertical_position, 500)
      //     return
      //   }

      //   if (inner_container_height >= view_port_height){
      //     $inner_container.css("margin-top", "0")
      //     return
      //   }

      //   // # We want to center the modal vertically on start
      //   // # So set the spacing between page top to remaining height / 2
      //   let remaining_space_height = view_port_height - inner_container_height
      //   $inner_container.css("margin-top", "#{remaining_space_height / 2}px")
      // }
      // adjust_vertical_position()
    }
    catch (err){
      reject(err)
    }
  })
}

export default {init_with_promise}
